import { render, staticRenderFns } from "./device-page.vue?vue&type=template&id=70603fbb"
import script from "./device-page.vue?vue&type=script&lang=js"
export * from "./device-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports